import { tabs } from './../../assets/data/tabs.js';
export default {
     data() {
          return {
               navs: tabs
          }
     },
}